// External Imports
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Local Imports
import picCarla from '../../assets/images/carla.webp';
import backpackCutout from '../../assets/images/backpack-cutout.webp';
import picAssion from '../../assets/images/assion.webp';
import vespaCutout from '../../assets/images/vespa-cutout.webp';
import picMario from '../../assets/images/mario.webp';
import orangeCutout from '../../assets/images/orange-cutout.webp';
import picDina from '../../assets/images/dina.webp';
import dogCutout from '../../assets/images/dog-cutout.webp';

export const getClasses = (t) => [
  {
    illustration: {
      backgroundColor: tokens.color.theme.light.illustration.dandelion.dark,
      cutout: vespaCutout,
    },
    language: t.classes.cards.card1.language,
    languageCode: 'FRA',
    level: t.classes.cards.card1.level,
    nonTranslatedLanguage: 'French',
    teacher: {
      name: t.classes.cards.card1.teacher,
      picture: picAssion,
    },
    textColor: 'inverse',
    title: t.classes.cards.card1.title,
  },
  {
    illustration: {
      backgroundColor: tokens.color.violet.violet200,
      cutout: dogCutout,
    },
    language: t.classes.cards.card2.language,
    languageCode: 'DEU',
    level: t.classes.cards.card2.level,
    nonTranslatedLanguage: 'German',
    teacher: {
      name: t.classes.cards.card2.teacher,
      picture: picDina,
    },
    textColor: 'default',
    title: t.classes.cards.card2.title,
  },
  {
    illustration: {
      backgroundColor: tokens.color.theme.light.illustration.emerald.dark,
      cutout: orangeCutout,
    },
    language: t.classes.cards.card3.language,
    languageCode: 'ITA',
    level: t.classes.cards.card3.level,
    nonTranslatedLanguage: 'Italian',
    teacher: {
      name: t.classes.cards.card3.teacher,
      picture: picMario,
    },
    textColor: 'inverse',
    title: t.classes.cards.card3.title,
  },
  {
    illustration: {
      backgroundColor: tokens.color.theme.light.illustration.emerald.default,
      cutout: backpackCutout,
    },
    language: t.classes.cards.card4.language,
    languageCode: 'SPA',
    level: t.classes.cards.card4.level,
    nonTranslatedLanguage: 'Spanish',
    teacher: {
      name: t.classes.cards.card4.teacher,
      picture: picCarla,
    },
    textColor: 'default',
    title: t.classes.cards.card4.title,
  },
];
